import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";

export const Route = createFileRoute("/samla-lan")({
  head: () => ({
    meta: [
      { title: "Samla lån – Sänk räntan och få en avi | Svensk Låneguide" },
      { name: "description", content: "Samla dyra krediter och SMS-lån till ett förmånligt samlingslån." },
      { property: "og:title", content: "Samla lån – Sänk räntan" },
      { property: "og:description", content: "Samla dyra krediter till ett lån." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="samla-lan"
      productLabel="Samlingslån"
      headingBefore="Samla dina lån och"
      underlined="sänk månadskostnaden"
      headingAfter=""
      subtitle={
        <>
          Samla lån och krediter i ett förmånligt <Link to="/nyhet/$slug" params={{ slug: "samla-lan-2026" }} className="text-primary underline underline-offset-2">samlingslån</Link> för bättre överblick och lägre räntekostnader. Jämför alla banker som erbjuder samlingslån nedan – sänk månadskostnaden och spara tusenlappar varje år. Vi går igenom vilka banker som är bäst, vad du bör tänka på innan ansökan och mycket mer.
        </>
      }
      featuredTitleTemplate={(m) => `Toppval för samlingslån i ${m}`}
    />
  ),
});
